<template>
	<div>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'list-stock-opname'">Data Stok Opname</div>
			<div class="text-h5" v-if="$route.name == 'list-stock-opname-warehouse'">Data Stok Opname Warehouse</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link class="text-deco" :to="{ name: 'add-stock-opname' }" v-if="hasAccess('add-stock-opname')">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Buat Stok Opname</div>
							</v-btn>
						</router-link>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Kode Stok Opname" v-model="opname_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalOpname)" label="Tanggal Stok Opname" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalOpname"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Penanggung Jawab" v-model="opname_pic.value"></v-text-field>
							</v-col>
              <v-col cols="12" md="3">
                <v-autocomplete v-if="$route.name == 'list-stock-opname-warehouse'" outlined dense hide-details v-model="opname_warehouse.value" :items="warehouseResults" label="Warehouse" item-text="warehouse_name" item-value="warehouse_id" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
              <v-col cols="12" md="9" class="text-right">
              </v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<div>
				<v-card outlined v-if="listOpname.length == 0 && opnamePagination" class="mt-3">
					<div class="py-3">
						<not-found></not-found>
					</div>
				</v-card>
				<div v-else>
					<v-row class="mr-0">
						<v-col cols="12" md="6" class="pb-0 pr-0" v-for="opname in listOpname" :key="opname.opname_id">
							<v-card outlined>
								<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
									<v-list-item dense>
										<v-list-item-content class="grey--text text--darken-2">
											Kode {{ opname.product_stock_opname_code }}
										</v-list-item-content>
										<v-spacer></v-spacer>
										<v-btn small text depressed class="primary" @click="printStockOpname(opname.product_stock_opname_code)">
											<v-icon>mdi-printer</v-icon>
											<div class="pl-2 text-capitalize">Print</div>
										</v-btn>
									</v-list-item>
								</v-list>
								<v-list-item>
									<v-list-item-content>
										<v-layout wrap>
											<v-flex xs6 sm6 md6>
												<div class="body-2 oppacity-75">Penanggung Jawab</div>
												<div class="subtitle-2 text-capitalize">{{ opname.product_stock_opname_pic_name }}</div>
												<div class="body-2 pt-3 oppacity-75">Tanggal Stok Opname</div>
												<div class="subtitle-2">{{ opname.product_stock_opname_datetime | haritanggal }}</div>
                        <div class="body-2 pt-3 oppacity-75" v-if="$route.name == 'list-stock-opname-warehouse'">Warehouse</div>
												<div class="subtitle-2" v-if="$route.name == 'list-stock-opname-warehouse'">{{ opname.warehouse_name }}</div>
											</v-flex>
											<v-flex xs6 sm6 md6>
												<div class="body-2 oppacity-75">Catatan</div>
												<div class="subtitle-2">{{opname.product_stock_opname_note}}</div>
												<div class="pt-5">
                          <span class="body-2 mr-2">{{opname.opname_status | toOpnameStatus}}</span>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(opname.product_stock_opname_code)">
																<v-icon dark>mdi-text-box-search</v-icon>
															</v-btn>
														</template>
														<span>Detail</span>
													</v-tooltip>
                          <v-tooltip bottom v-if="hasAccess('approval-stock-opname') && opname.opname_status == 'created'">
														<template v-slot:activator="{ on, attrs }">
                              <router-link class="text-deco" :to="{ name: 'approval-stock-opname', params: { code: opname.product_stock_opname_code }}">
                                <v-btn class="mr-2" fab dark x-small depressed color="primary" v-bind="attrs" v-on="on">
                                  <v-icon dark>mdi-check</v-icon>
                                </v-btn>
                              </router-link>
														</template>
														<span>Detail</span>
													</v-tooltip>
												</div>
											</v-flex>
										</v-layout>
									</v-list-item-content>
								</v-list-item>
							</v-card>
						</v-col>
					</v-row>
					<div class="pt-5">
						<v-row v-if="opnamePagination">
							<v-col cols="12" md="11" class="py-0 d-flex justify-end">
								<v-pagination v-model="page" :length="opnamePagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
							</v-col>
							<v-col cols="12" md="1" class="py-0 pl-0">
								<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
							</v-col>
						</v-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState } from 'vuex'
import modalDetail from '@/views/MLwarehouse/stockOpname/DetailStockOpname'
import modalPrint from '@/views/MLwarehouse/stockOpname/PrintStockOpname'

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			menu: false,
			dropfilter: false,
			dialog: false,
			dialogPrint: false,
			loading: true,
			tanggalOpname: [],
			sortBy: 'product_stock_opname_id',
			sortDir: 'DESC',
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			params:[],
			procces_po_id: '',
			poProccess : '',
			headersProduct: [
			{ text: 'Nama Produk', value: 'product_stock_opname_detail_product_name', sortable: false },
			{ text: 'Tipe', value: 'product_stock_opname_detail_type', align: 'center'},
			{ text: 'Jumlah', value: 'product_stock_opname_detail_quantity', align: 'center'},
			],
			opname_code: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'product_stock_opname_code'
			},
			dataDetailOpname: {},
			opname_pic: {
				value: '',
				comparison: 'like',
				type: 'string',
				field: 'product_stock_opname_pic_name'
			},
        opname_warehouse: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'product_stock_opname_warehouse_id'
			},
			opname_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'product_stock_opname_datetime'
			},
		}
	},
	computed: {
		...mapState('stockOpname', ['listOpname', 'opnamePagination', 'warehouseResults']),
	},
	methods: {
		...mapActions('stockOpname', ['getOpname', 'getOpnameAll', 'exportOpname', 'exportOpnameAll', 'getDetailOpname', 'getWarehouseOption']),
		...mapActions('common', ['getLetterHeader']),

		exportData(){
      if (this.$route.name == 'list-stock-opname-warehouse') {
        this.exportOpnameAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
      } else {
        this.exportOpname(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
      }
		},
		getData() {
      if (this.$route.name == 'list-stock-opname-warehouse') {
        this.getOpnameAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
				this.loading = false
			})
      } else {
        this.getOpname(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
          this.loading = false
        })
      }
		},
		/*showDetail(data) {
			this.dataDetailOpname = Object.assign({}, data)
			this.getDetailOpname(data.product_stock_opname_code)
		}*/
		getDetail(code) {
			this.getDetailOpname(code).then(()=> {
				this.dialog = true
			})
		},
		resetFilter(){
			this.opname_code.value = ''
			this.opname_date.value = ''
			this.opname_pic.value = ''
			this.tanggalOpname = []
			this.page = 1
			this.getData()
		},
		cari(){
			this.params = []
			if (this.opname_code.value)
				this.params.push(this.opname_code)
			if (this.opname_pic.value)
				this.params.push(this.opname_pic)
			if (this.opname_date.value){
				if (this.opname_date.value.length > 1) {
					this.opname_date.value.sort()
					let date = this.opname_date.value.join('::')
					this.opname_date.value = date
				}
				this.params.push(Object.assign({}, this.opname_date))
			}
			this.page = 1
			this.getData()
		},
		changePage(page){
			this.page = page
			this.getData()
		},
		async printStockOpname(code) {
			await this.getLetterHeader()
			await this.getDetailOpname(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Penyesuaian Stok`)
		this.getData()
    if (this.$route.name == 'list-stock-opname-warehouse') {
      this.getWarehouseOption()
    }
	},
	watch: {
		tanggalOpname(val) {
			this.opname_date.value = val
		},
		limit() {
			this.page = 1
			this.getData()
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>
